<adapt-activity-section-collapsible [section]="section"
                                    [count]="displayedCount"
                                    [totalCount]="activityGroup.totalCount"
                                    [countTooltip]="countTooltip"
                                    [fallbackText]="fallbackText"
                                    [isLoading]="isLoading"
                                    [error]="error">
    @if (overdueObjectiveGroups?.length || upcomingObjectiveGroups?.length) {
        <div class="d-flex flex-row flex-wrap gap-3">
            @if (overdueObjectiveGroups && overdueObjectiveGroups.length > 0) {
                <adapt-universal-dashboard-element name="Activities due"
                                                   [background]="false"
                                                   [nested]="true">
                    <div class="objective-groups">
                        @for (objectiveTeamGroup of overdueObjectiveGroups; track objectiveTeamGroup) {
                            <div>
                                <adapt-link-objectives-page *adaptIfAlto="false"
                                                            [team]="objectiveTeamGroup.team"
                                                            class="objectives-team-label"></adapt-link-objectives-page>
                                <div class="d-flex flex-column objectives">
                                    @for (objective of objectiveTeamGroup.objectives; track objective) {
                                        <adapt-objective-dashboard-summary [objective]="objective"
                                                                           [displayAssignee]="false"
                                                                           [class.overdue]="objective.isOverdue"></adapt-objective-dashboard-summary>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </adapt-universal-dashboard-element>
            }
            @if (upcomingObjectiveGroups && upcomingObjectiveGroups.length > 0) {
                <adapt-universal-dashboard-element name="Upcoming"
                                                   [background]="false"
                                                   [nested]="true">
                    <div class="objective-groups">
                        @for (objectiveTeamGroup of upcomingObjectiveGroups; track objectiveTeamGroup) {
                            <div>
                                <adapt-link-objectives-page *adaptIfAlto="false"
                                                            [team]="objectiveTeamGroup.team"
                                                            class="objectives-team-label"></adapt-link-objectives-page>
                                <div class="d-flex flex-column objectives">
                                    @for (objective of objectiveTeamGroup.objectives; track objective) {
                                        <adapt-objective-dashboard-summary [objective]="objective"
                                                                           [displayAssignee]="false"
                                                                           [class.overdue]="objective.isOverdue"></adapt-objective-dashboard-summary>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </adapt-universal-dashboard-element>
            }
        </div>
    }
</adapt-activity-section-collapsible>
